import Auth from './Auth';

const useUserIsPermitted = () => {
  const isAuthenticated = !!Auth.isAuthorized();

  return isAuthenticated;
};

const hasPrivilege = () => {
  const privilege = !!Auth.hasPrivilege();
  return privilege;
};

export { hasPrivilege, useUserIsPermitted };
